import i18n from "src/app/shared/localization/i18n";
export interface IAnswer {
    text: string;
    alternativeText1: string;
    alternativeText2: string;
    edited_Text: string | null;
    edited_AlternativeText1: string | null;
    edited_AlternativeText2: string | null;
    answerId: number;
    buttons: INlpButton[];
    parametersJson: object;
}

export interface INlpButton {
    type: NlpButtonType;
    name: string;
    value: string;
}

export enum NlpButtonType {
    Text = 1,
    Link,
    Trigger,
    CustomEvent,
    Back,

    RequestContact = 10,
    RequestGeolocation = 11,
}

export const createNlpButton = (): INlpButton => {
    return {
        type: NlpButtonType.Trigger,
        name: "",
        value: ""
    }
}

export const nlpButtonTypeToString = (buttonType: NlpButtonType): string => {
    switch (buttonType) {
        case NlpButtonType.Trigger:
            return i18n.t('nlp.nlpButtonType_trigger');
        case NlpButtonType.Text:
            return i18n.t('nlp.nlpButtonType_text');
        case NlpButtonType.Link:
            return i18n.t('nlp.nlpButtonType_link');
        case NlpButtonType.CustomEvent:
            return i18n.t('nlp.nlpButtonType_customEvent');
        case NlpButtonType.Back:
            return i18n.t('nlp.nlpButtonType_back');
        case NlpButtonType.RequestContact:
            return i18n.t('nlp.nlpButtonType_requestContact');
        case NlpButtonType.RequestGeolocation:
            return i18n.t('nlp.nlpButtonType_requestGeolocation');
        default:
            return i18n.t('nlp.nlpButtonType_trigger');
    }
}
